import React from 'react';
import PropTypes from 'prop-types';

import Form from '@appComponents/ReduxFormControls';
import {BookingsDatesFields} from '@modules/booking/components/BookingsDatesFields';
import {PropertyLicencesFilter} from '@utils/commonFilters/PropertyLicencesFilter';
import {EventTypeFilter} from '@utils/commonFilters/EventTypeFilter';
import {TiersFilter} from '@utils/commonFilters/TiersFilter';
import {ContentCategoriesLevel1Filter} from '@utils/commonFilters/contentCategories/ContentCategoriesLevel1Filter';
import {ContentCategoriesLevel2Filter} from '@utils/commonFilters/contentCategories/ContentCategoriesLevel2Filter';
import {ContentCategoriesLevel3Filter} from '@utils/commonFilters/contentCategories/ContentCategoriesLevel3Filter';
import {SportsFilter} from '@utils/commonFilters/SportsFilter';
import {TournamentsFilter} from '@utils/commonFilters/TournamentsFilter';
import {TournamentCategoriesFilter} from '@utils/commonFilters/TournamentCategoriesFilter';
import {StageCategoryFilter} from '@utils/commonFilters/StageCategoryFilter';

export const BookingsFiltersFields = (props) => {
    const {
        additionalFilterId,
        clientFilters,
        dateConfigProps,
        loading,
        restoreFilterValues,
        state,
        data: {
            propertyLicences,
            eventTypes,
            contentTiers,
        },
        methods: {
            onEventTypeChange,
            onSportChange,
            onTournamentCategoryChange,
            onTournamentChange,
            onContentCategoryLevel1Change,
            onContentCategoryLevel2Change,
            onContentCategoryLevel3Change,
            onFirstStageCategoryChange,
            onSecondStageCategoryChange,
        },
    } = props;

    return (
        <>
            <Form.IdField
                defaultValue={additionalFilterId}
                name='client'
            />
            <BookingsDatesFields {...{loading, clientFilters, dateConfigProps, restoreFilterValues}}/>
            <PropertyLicencesFilter
                propertyLicences={propertyLicences}
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <EventTypeFilter
                eventTypes={eventTypes}
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
                onChangeValue={onEventTypeChange}
            />
            <SportsFilter
                sports={state.sports}
                loading={state.sportsLoading || loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
                hidden={!state.showSportFilter}
                onChangeValue={onSportChange}
            />
            <TournamentCategoriesFilter
                tournamentCategories={state.tournamentCategories}
                loading={state.tournamentCategoriesLoading || loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
                onChangeValue={onTournamentCategoryChange}
                hidden={!state.hasSelectedSport || state.isStageEvent}
            />
            <TournamentsFilter
                tournaments={state.tournaments}
                loading={state.tournamentCategoriesLoading || state.tournamentsLoading || loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
                hidden={!state.hasSelectedTournamentCategory}
                onChangeValue={onTournamentChange}
            />
            <StageCategoryFilter
                level='level1'
                options={state.firstStageCategories}
                loading={state.firstStageCategoriesLoading || loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
                hidden={!state.isStageEvent || !state.hasSelectedSport}
                onChangeValue={onFirstStageCategoryChange}
            />
            <StageCategoryFilter
                level='level2'
                options={state.secondStageCategories}
                loading={state.firstStageCategoriesLoading || state.secondStageCategoriesLoading || loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
                hidden={!state.isStageEvent || !state.hasSelectedFirstStageCategory}
                onChangeValue={onSecondStageCategoryChange}
            />
            <ContentCategoriesLevel1Filter
                loading={state.contentCategoriesLevel1Loading || loading}
                hidden={!state.hasContentCategoryLevel1}
                options={state.contentCategoriesLevel1}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
                onChangeValue={onContentCategoryLevel1Change}
            />
            <ContentCategoriesLevel2Filter
                loading={state.contentCategoriesLevel2Loading || loading}
                hidden={!state.hasSelectedContentCategoryLevel1}
                options={state.contentCategoriesLevel2}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
                onChangeValue={onContentCategoryLevel2Change}
            />
            <ContentCategoriesLevel3Filter
                loading={state.contentCategoriesLevel2Loading || state.contentCategoriesLevel3Loading || loading}
                hidden={!state.hasSelectedContentCategoryLevel2}
                options={state.contentCategoriesLevel3}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
                onChangeValue={onContentCategoryLevel3Change}
            />
            <TiersFilter
                contentTiers={contentTiers}
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
        </>
    );
};

BookingsFiltersFields.propTypes = {
    additionalFilterId: PropTypes.string,
    clientFilters: PropTypes.object,
    dateConfigProps: PropTypes.object,
    loading: PropTypes.bool,
    restoreFilterValues: PropTypes.func,
    state: PropTypes.object,
    data: PropTypes.shape({
        propertyLicences: PropTypes.array,
        eventTypes: PropTypes.array,
        contentTiers: PropTypes.array,
    }),
    methods:
        PropTypes.shape({
            onEventTypeChange: PropTypes.func,
            onSportChange: PropTypes.func,
            onTournamentCategoryChange: PropTypes.func,
            onTournamentChange: PropTypes.func,
            onContentCategoryLevel1Change: PropTypes.func,
            onContentCategoryLevel2Change: PropTypes.func,
            onContentCategoryLevel3Change: PropTypes.func,
            onFirstStageCategoryChange: PropTypes.func,
            onSecondStageCategoryChange: PropTypes.func,
        }),
};
